import { HStack } from '@sgme/ui';

import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';

import { AtmVolatilityOrMessage } from './AtmVolatilityOrMessage.tsx';
import { MidVolatility } from './MidVolatility.tsx';
import { Rate } from './Rate.tsx';

type StreamingProps = {
  tileId: string;
  executable?: boolean;
};

export function Streaming({ tileId, executable = false }: StreamingProps) {
  const streamStatus = useOptionSelector((option) => option.properties.rfs.status);
  const expiredPrice = streamStatus === 'EXPIRED';

  return (
    <HStack
      fullWidth
      className="position-relative"
      data-e2e="rates"
      data-e2e-status={expiredPrice ? 'expired' : 'pricing'}
    >
      <HStack horizontalAlignment="center" className="position-absolute top-0 start-0 end-0">
        <AtmVolatilityOrMessage />
      </HStack>

      <div className="d-flex justify-content-between w-100" style={{ height: '100px' }}>
          <Rate tileId={tileId} way="Bid" executable={executable} />
          <Rate tileId={tileId} way="Ask" executable={executable} />
      </div>

      <div className="d-flex flex-center position-absolute bottom-0 start-0 end-0">
        <MidVolatility />
      </div>
    </HStack>
  );
}


